<!--  -->
<template>
  <div class="PayBill">
    <div class="content">
      <div class="formbox">
        <div class="bigtitle">专利年费委托缴费单</div>
        <div class="ulbox tiandan">
          <div class="lidiv">填单人：
            <img :src="wxData.headimgurl" alt="" width="20px" class="icon">
            <span style="margin-left: 20px;">{{ wxData.nickname }}</span>
          </div>
          <div class="lidiv">填单日期：{{ nowdate }}</div>
        </div>
        <div class="infobox">
          <div class="infoboxs">
            <div class="infoname"><strong>案件信息</strong></div>
            <div class="infodiv">
              <div class="infoli">
                <div class="lititle">申请人：</div>
                <div class="licss">{{ PayBillInfo.reg_name }}</div>
              </div>
              <div class="infoli">
                <div class="lititle">申请号：</div>
                <div class="licss">{{ PayBillInfo.reg_num }}</div>
              </div>
            </div>
            <div class="infodiv">
              <div class="lititle">专利名称：</div>
              <div class="licss">{{ PayBillInfo.project_name }}</div>
            </div>
            <div class="infodiv" style="margin-top: 20px;">最迟缴费日期：
              <strong>{{ PayBillInfo.pay_tip }}前
                <span style="color:green;">({{ PayBillInfo.dayTip }})</span>
              </strong>
              <span style="color:red;" v-if="PayBillInfo && PayBillInfo.feeTip">{{ PayBillInfo.feeTip }}</span>
            </div>
            <div class="infodiv">
              缴纳年费官费：<input type="text" class="money" v-model="BillInfo.guanfei" placeholder="0.00">元；
              滞纳金：<input type="text" class="money" v-model="BillInfo.zhinajin" placeholder="0.00">元；
              代理费：<input type="text" class="money" v-model="BillInfo.dailifei" placeholder="100.00" readonly>元；
            </div>
          </div>
          <div class="infoboxs">
            <div class="infoname"><strong>付款备注（合计：{{ formattedTotalAmount }}）</strong></div>
            <div class="infodivs">
              <div class="bigname">
                ￥<div class="numcss"><strong id="numcss">{{ formattedTotalAmount }}</strong></div>
              </div>
              <div class="bigli">
                <textarea name="remarks" v-model="BillInfo.beizhu" rows="3" placeholder="缴费备注信息"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnbox">
        <el-button type="success" icon="el-icon-check" @click="sbumitInfo">提交</el-button>
        <el-button type="danger" icon="el-icon-close" @click="closebox">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { entrustedPayment } from '@/api/index'
export default {
  name: "PayBill",
  components: {},
  props: ['PayBillInfo'],
  data() {
    return {
      BillInfo: {
        guanfei: null,
        zhinajin: null,
        dailifei: '100.00',
        beizhu: '',
      }
    };
  },
  computed: {
    totalAmount() {
      const { guanfei, zhinajin, dailifei } = this.BillInfo;
      // 处理可能为null的情况，将null转换为0
      const amount1 = guanfei ==null ? 0 : guanfei;
      const amount2 = zhinajin == null ? 0 : zhinajin;
      return Number(amount1) + Number(amount2) + Number(dailifei);
    },
    formattedTotalAmount() {
      return this.totalAmount.toFixed(2);
    },
    nowdate() {
      const now = new Date();
      const dateString = now.toISOString().split('T')[0];
      return dateString;
    }
  },
  methods: {
    closebox() {
      this.BillInfo = {
        guanfei: null,
        zhinajin: null,
        dailifei: '100.00'
      }
      this.$emit('update:PayBill', false)
    },
    async sbumitInfo() {
      let params = {}
      params.id = this.PayBillInfo.id
      params.aid = this.wxData.aid
      params.wxid = this.wxData.id
      params.official_fee = this.BillInfo.guanfei
      params.late_fee = this.BillInfo.zhinajin
      params.official_fee_a = this.BillInfo.dailifei
      params.remarks = this.BillInfo.beizhu
      params.pay_term = this.PayBillInfo.pay_tip
      console.log(params)
      try {
        let req = await entrustedPayment(params)
        console.log(req)
        if (req.state == 'ok') {
          this.$message({ message: req.message, type: 'success', offset: 500, duration: 1500 })
          this.$emit('upevent')
          this.closebox()
        } else {
          this.$message({ message: req.message, type: 'error', offset: 500, duration: 1500 })
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  mounted() {
    this.$set(this.BillInfo, 'guanfei', this.PayBillInfo.newFee)
    console.log(this.PayBillInfo)
  },
}
</script>
<style lang='scss' scoped>
.PayBill {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.3);
}

.content {
  min-width: 800px;
  min-height: 500px;
  background-color: white;
  border-radius: 4px;
  padding: 40px;
  position: relative;
}

.closewindow {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  font-size: 24px;
}

.formbox {
  letter-spacing: 1px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgb(255, 217, 192);
  position: relative;
  line-height: 1.3;
}

.bigtitle {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  font-size: 24px;
  text-align: center;
  // border-bottom: thick double rgba(0, 0, 0, 0.7);
  margin: 10px 0px;
  margin-top: 20px;
}

.ulbox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  // background-color: red;
  align-items: center;
}

.lidiv {
  width: 48%;
  margin: 10px 0;
}

.infobox {
  width: 100%;
  border: 2px solid rgba(0, 0, 0, 1);
}

.infoboxs {
  border-bottom: 1px solid rgba(0, 0, 0, 1);
  padding: 8px 12px;
}

.infoboxs:last-child {
  border: 0;
}

.infoname {
  color: rgba(0, 0, 0, 0.7);
  font-size: 12px;
  margin-bottom: 10px;
}

.infodiv {
  width: 100%;
  display: flex;
  margin: 6px 0;
}

.infoli {
  width: 50%;
  display: flex;
  align-items: center;
}

.infoli:last-child {
  margin-left: 6px;
}

.lititle {
  flex-shrink: 0;
}

.licss {
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.7);
}

input {
  border: 0 !important;
  outline: none !important;
  background: none !important;
}

input[type="checkbox"] {
  margin: 0 !important;
  margin-right: 4px !important;
}

input[type="text"] {
  background: rgba(255, 255, 255, 0.6) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.7) !important;
  width: 74px;
}

.infodivs {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bigname {
  display: flex;
  font-size: 24px;
  width: 35%;
}

.numcss {
  background: linear-gradient(rgba(0, 0, 0, 0.2) 20%, rgba(0, 0, 0, 0.2) 80%);
}

.bigli {
  width: 65%;
}

textarea {
  border: 0 !important;
  outline: none !important;
  background: none !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  background: rgba(255, 255, 255, 0.6) !important;
  width: 100%;
}

textarea::-webkit-input-placeholder {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.2);
  font-weight: bolder;
}

.null {
  border-bottom: 1px solid rgba(0, 0, 0, 0.7) !important;
  width: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btnbox {
  display: flex;
  justify-content: space-between;
  padding: 0 260px;
  margin-top: 40px;
}

strong {
  font-weight: bold;
}

.tiandan {
  position: relative;
}

.icon {
  vertical-align: baseline;
  position: absolute;
  top: 8px;
  border-radius: 4px;
  left: 70px;
}
</style>